<template lang="pug">
.side-modal
	.sidemodal-background(v-if="value", @click="closeSideModal")
	.modal-container.p-2(:class="{'is-open': value}", :style="getSideModalSize")
		.d-flex.align-items-center.py-2.px-1
			x-icon.pointer(@click="closeSideModal")
			b-spinner.ml-3(small, variant="primary", v-if="loading")
		.slot-container.scrollable-area.overflow-y(:style="{padding: padding || ''}")
			slot
</template>


<script>
import mixpanel from '@/mixpanel';

export default {
	data () {
		return {
			close_padding: '30px',
			container_padding: '0 30px 30px'
		}
	},
	mode: {
		prop: 'value',
		event: 'input'
	},
	name: 'SideModal',
	methods: {
		closeSideModal () {
			this.$emit('input', !this.value)
		}
	},
	props: {
		size: {
			type: String,
			default: 'md'
		},
		padding: {
			type: String,
			default: null
		},
		value: {
			type: Boolean,
			default: false
		},
		loading: {
			type: Boolean,
			default: false
		},
		width: {
			type: Number,
			default: 0
		}
	},
	computed: {
		getSideModalSize () {
			let size = 400

			if (this.width != undefined && this.width > 0) {
				size = this.width
			} else {
				if (this.size == 'lg') {
					if (this.$breakpoint.md) {
						return {
							width: '90%',
							right: '-90%'
						}
					} else {
						return {
							width: '100%',
							right: '-100%'
						}
					}
				}

				switch (this.size) {
					case 'md':
						size = 400
						break
					case 'sm':
						size = 300
						break
				}
			}

			return {width: `${size}px`, right: `-${size}px`}
		}
	},
	watch: {
		value (open) {
			if(open){
				mixpanel.track('Side Modal: Open', {
					account_id: this.$route.params.account_id,
					unique_id: this.getCurrentUser().email,
					admin_id: this.getCurrentUser().email_id,
					role_id: this.getCurrentUser().role_id
				});
			}
			setTimeout(() => {
				this.$emit(open == true ? 'open' : 'close')
			}, 500)
		}
	}
}
</script>

<style lang="scss" scoped>
	.side-modal {
		position: fixed;
		z-index: 1000;
	}

	.modal-container {
    width: 400px;
		overflow: hidden;
    overflow-y: auto;
    border-left: 1px solid #e3ebf6;
    background-color: white;
    position: fixed;
    top: 0;
    bottom: 0;
    right: -400px;
		transition: 0.5s;
		max-width: 100%;
  }

	.sidemodal-background {
		position: fixed;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		background-color: rgba(0, 0, 0, 0.1);
  }

  .slot-container {
    height: calc(100% - 45px);
    padding-bottom: 10px;
  }

	@media (max-width: 425px) {
    .modal-container {
			border-left: none;

			&.is-open {
        right: 0 !important;
				width: 100%;
      }
    }
  }

  @media (min-width: 426px) {
    .modal-container {
      &.is-open {
        right: 0 !important;
      }
    }
  }

	.close-button {
		display: block;
	}

	slot.container {
		padding: 0 1rem 1rem;
	}
</style>
